import { z } from 'zod';

export const schemaConsorsTelephone = z
    .string()
    .min(8)
    .max(15)
    .transform((val) => (val.length <= 14 ? val.replace(/^\+/, '00') : val.replace(/^\+/, '0')))
    .refine(
        (val) => {
            if (val === undefined) return true;
            return /^0[0-9/() -]+$/.test(val);
        },
        { message: 'Invalid characters' },
    );

export type SchemaConsorsTelephone = z.infer<typeof schemaConsorsTelephone>;
